<template>
  <div class="chart-container" style="position: relative; width:100%">
    <bar-chart v-if="chartData" :chartData="chartData" />
  </div>
</template>

<script>
import { BarChart } from 'components/charts/charts'
import { post } from 'providers/http'

export default {
  name: 'event-statistics',
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      data: null,
      timerId: null
    }
  },
  computed: {
    chartData () {
      if (!this.data) {
        return null
      }
      const dataSet = this.data.reduce((acc, curr) => {
        return {
          data: [...acc.data, curr.count],
          labels: [...acc.labels, curr.time]
        }
      }, {data: [], labels: []})

      return {
        labels: dataSet.labels,
        datasets: [{
          label: '# of events',
          data: dataSet.data,
          backgroundColor: 'rgb(87, 193, 123)',
          borderColor: 'rgb(87, 193, 123)',
          borderWidth: 1
        }]
      }
    }
  },
  methods: {
    async _fetchStatistics () {
      const data = await post('api/v1/events/statistics', this.filters)

      this.data = data
    },
    refresh () {
      this._fetchStatistics()
      this.timerId = setTimeout(this.refresh, 15 * 1000)
    }
  },
  created () {
    this.refresh()
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },
  components: {
    BarChart
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// EventStatistics.vue?c63955d2